import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";
import SectionDivider from "@/components/SectionDivider";
import SunRays from "@/components/SunRays";

export default function CTABanner() {
  return (
    <>
      <section className="py-16 md:py-20 bg-flowing-gradient texture-halftone texture-noise relative overflow-hidden">
        <SunRays variant="full" className="opacity-50" />


        <div className="container text-center relative z-10">
          <h2 className="text-3xl md:text-5xl font-black text-primary-foreground mb-4" style={{ textShadow: "3px 3px 0px hsl(174 72% 25%)" }}>
            Ready to Beat the Arizona Heat?
          </h2>
          <p className="text-lg text-primary-foreground/85 mb-8 max-w-xl mx-auto">
            Join hundreds of happy Phoenix homeowners. Get your free estimate today — no pressure, no hassle.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="hero" size="xl" className="glow-pulse" asChild>
              <Link to="/contact">
                Get Free Quote
                <ArrowRight className="w-5 h-5" />
              </Link>
            </Button>
            <Button variant="hero-outline" size="xl" asChild>
              <a href="tel:+16233014595">
                <Phone className="w-5 h-5" />
                (623) 301-4595
              </a>
            </Button>
          </div>
        </div>
      </section>
      <SectionDivider variant="doublewave" fillClass="fill-warm-white" />
    </>
  );
}
